import { create } from "zustand";

/**
 * 리뷰별 댓글 개수.
 *
 * 왜 필요한가
 * ----------
 * 홈 피드가 보여주는 댓글 수는 목록을 받아올 때의 값이다. 그런데 홈은 목록을
 * sessionStorage 스냅샷에 저장해 두고 다른 화면에 다녀오면 그걸로 복원하는데,
 * 스냅샷은 댓글을 달아도 갱신되지 않는다.
 *
 * 그래서 "댓글 작성 → 뒤로가기" 하면 피드의 댓글 수가 예전 값으로 돌아갔다.
 * 좋아요가 되돌아가던 것과 같은 원인이다(likeStore의 dirtyIds 주석 참고).
 *
 * 리뷰 상세에서 댓글 목록을 읽을 때마다 실제 개수를 여기에 적어 두고,
 * 피드는 이 값이 있으면 그걸 먼저 쓴다. 앱을 다시 켜면 비워져 서버 값으로 돌아간다.
 */
interface CommentCountStore {
  counts: Map<string, number>;
  /** 리뷰 상세가 실제로 센 댓글 수를 알려준다 */
  setCount: (reviewId: string, count: number) => void;
  /** 피드가 보여줄 값. 적어둔 게 없으면 목록이 준 값을 그대로 쓴다. */
  getCount: (reviewId: string, fallback: number) => number;
}

export const useCommentCountStore = create<CommentCountStore>((set, get) => ({
  counts: new Map(),

  setCount: (reviewId: string, count: number) => {
    const { counts } = get();
    if (counts.get(reviewId) === count) return; // 같으면 리렌더 안 만든다
    const next = new Map(counts);
    next.set(reviewId, count);
    set({ counts: next });
  },

  getCount: (reviewId: string, fallback: number) => {
    return get().counts.get(reviewId) ?? fallback;
  },
}));
